import store from '../store';

const groupRoutes = [
	{ 
		path: '/groups/list', 
		name: 'groups.list',
		component: require('../pages/groups/GroupList.vue').default
	},

	{ 
		path: '/groups/:id', 
		name: 'groups.show',
		component: require('../pages/groups/GroupProfile.vue').default,
		props(route) {
			const props = { ...route.params };
			props.id = +props.id;
			return props;
		},
	},
	
];

export default groupRoutes;